/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react/react-in-jsx-scope */
import { Box, Button, Typography, Paper, Divider, Stack } from '@mui/material';
import { buildB2CLoginUrl } from '../../utils/pkce';

export default function LoginOptions(): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleB2CLogin = async () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    const url = await buildB2CLoginUrl();
    window.location.href = url;
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handle3MLogin = () => {
    const internal3MLoginUrl = process.env.REACT_APP_LOGIN_URL ?? '';
    window.location.href = internal3MLoginUrl;
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          padding: { xs: 4, md: 6 },
          borderRadius: 4,
          maxWidth: 450,
          width: '90%',
          textAlign: 'center',
          bgcolor: 'rgba(255, 255, 255, 0.9)',
        }}
      >
        {/* Logo 3M */}
        <Box mb={3}>
          <img 
            src={require('../../assets/images/3M_Active Safety_RGB_H43.png')} 
            alt='logo' 
            style={{ height: 40, marginBottom: 16 }} 
          />
        </Box>

        <Typography variant="h5" fontWeight="700" color="primary" gutterBottom>
          Welcome Back
        </Typography>
        
        <Typography variant="body2" color="text.secondary" mb={4}>
          Please select your preferred authentication method to continue to the system.
        </Typography>

        <Stack spacing={2}>
          {/* Nút B2C Login */}
          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={handleB2CLogin}
            sx={{
              height: 56,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1.1rem',
              fontWeight: '600',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
              },
              transition: 'all 0.2s',
            }}
          >
            Login with Azure B2C
          </Button>

          <Box sx={{ display: 'flex', alignItems: 'center', my: 1 }}>
            <Divider sx={{ flex: 1 }} />
            <Typography variant="caption" sx={{ px: 2, color: 'text.disabled' }}>
              OR
            </Typography>
            <Divider sx={{ flex: 1 }} />
          </Box>

          {/* Nút 3M Login */}
          <Button
            variant="outlined"
            size="large"
            fullWidth
            onClick={handle3MLogin}
            sx={{
              height: 56,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1.1rem',
              fontWeight: '600',
              color: '#d32f2f',
              borderColor: '#d32f2f',
              '&:hover': {
                borderColor: '#d32f2f',
                bgcolor: 'rgba(211, 47, 47, 0.04)',
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.2s',
            }}
          >
            Login with 3M
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
